import { FC } from 'react';
import { BannersTrustAllStoryblok } from 'storyblok-types';
import { StoryblokBannersTrustAllWrapper } from 'pages/StoryBlok/TrustBanner/StoryblokBannersTrustAll';
import { getRandomBanners } from 'pages/StoryBlok/TrustBanner/utils';
import { renderRichText } from 'modules/stroyblok/services';

export const StoryblokBannersTrustAllContainer: FC<{
  blok: BannersTrustAllStoryblok;
}> = ({ blok }) => {
  const hideOn = blok?.additional_options?.find(
    (item) => item.component === 'hide_on',
  );
  const visibleCount = blok?.visible_count?.length
    ? Number(blok?.visible_count)
    : blok?.banners?.length;
  const banners = getRandomBanners(blok?.banners || [], visibleCount);

  return (
    <StoryblokBannersTrustAllWrapper
      banners={banners}
      title={renderRichText(blok?.title)}
      hideOn={hideOn?.value}
    />
  );
};
